<template>
  <!-- Implementa la pagina di login ai servizi Salabam. Deve essere fatta una prima chiamata al backend    -->
  <!-- Welfarebit, il quale da in risposta un URL presso il quale ridirigere l'utente. Usiamo un componente -->
  <!-- perchè in base al parametro service passato, l'utente verrà rediretto presso un portale Salabam      -->
  <!-- piuttosto che un altro. -->

  <!-- Overlay di attesa durante la richiesta al backend dell'URL di redirect -->
  <CustomOverlay :show="overlay_show" :text="overlay_text">
    <b-card :title="service_title" class="mr-1 ml-1">
        <b-row>
          <b-col class="alert alert-warning" role="alert">
              <h5><b-icon icon="exclamation-triangle"></b-icon> IMPORTANTE:</h5>
              <p>Si rende noto che nel rispetto degli artt. 51 e 100 del Testo Unico Imposte sui Redditi, il beneficiario del Piano Welfare può effettuare acquisti tramite la piattaforma web nella sezione "{{service_title}}":</p>
              <p>- solo per le finalità indicate al comma 1 dell'art. 100 (educazione, istruzione, ricreazione, assistenza sociale e sanitaria o culto);</p>
              <p>- solo per sé o per i familiari indicati nell'art.433 del Codice Civile vigente, richiamato dall'art. 12 del Testo Unico Imposte sui Redditi.</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <p>Di seguito l'elenco dei soggetti che, oltre al titolare del piano welfare, possono beneficiare dei servizi acquistati:</p>
              <ul>
              <li>il coniuge (non legalmente ed effettivamente separato)</li>
              <li>i figli (legittimi o legittimati o naturali o adottivi) anche adottivi, e, in loro mancanza, i discendenti prossimi (anche naturali)</li>
              <li>i genitori e, in loro mancanza, gli ascendenti prossimo, anche naturali; gli adottanti</li>
              <li>il partner nelle unioni civili (Legge 20 maggio 2016, n.76)</li>
              <!-- <li>i generi e le nuore</li>
              <li>il suocero e la suocera</li>
              <li>i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</li> -->
              </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <!-- In questo caso usiamo il form solo per contenere la -->
              <!-- checkbox per la visualizzazione del bottone di accesso.-->
              <b-form>
                  <b-form-group id="group-ok-condizioni">
                      <b-form-checkbox
                      id="ok-condizioni"
                      name="ok-condizioni"
                      :value="true"
                      :unchecked-value="false"
                      v-model="conditions_checkbox"
                      required>
                      <span :class="conditions_text_bold ? 'font-weight-bold' : 'font-italic'">Il/la sottoscritto/a dichiara, sotto la propria responsabilità, che i dati relativi ai familiari che verranno inseriti sulla piattaforma sono veritieri e si impegna a modificarli qualora avvenissero vicende modificative di tali dati. In caso di verifica di nominativo non appartenente all’elenco di cui sopra autorizzo Welfarebit srl ad emettere nei miei confronti regolare fattura per i servizi acquistati.</span>
                      </b-form-checkbox>
                  </b-form-group>
                  <!-- Il bottone prende dal backend l'url verso il quale ridirigerci e apre la nuova finestra -->
                  <b-button v-if="show_submit_btn" variant="primary" @click="execute_sso">Accedi al portale {{service_title}}</b-button>
              </b-form>
          </b-col>
        </b-row>
        <!-- Uno slot per del contenuto addizionale sotto al form -->
        <slot name="form-footer"></slot>
    </b-card>
  </CustomOverlay>
</template>

<script>
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'SalabamLoginPage',
  data () {
    return {

      // Controllo dell'overlay.
      overlay_show: false,

      // Testo dell'overlay
      overlay_text: "Il portale del nostro partner si aprirà a breve, si prega di attendere...",

      // Checkbox di conferma delle condizioni
      conditions_checkbox: false
    }
  },
  computed : {
    /**
     * Visualizza o meno il bottone di invio del form sulla base del valore della checkbox.
     */
    show_submit_btn : function () {
      return  this.conditions_checkbox === true ? true : false;
    }
  },
  methods : {
    /**
     * Interrroga il backend per prendere l'url di redirect ed apre quindi il nuovo
     * tab riferito a quell'url, dopodichè passa alla pagina di cortesia che dopo
     * un pò ci riporta alla home.
     */
    execute_sso : function () {
      // Vi è un problema nell'uso di window.open con safari, infatti Safari blocca
      // l'uso di window.open all'interno di una funzione asincrona quindi non possiamo
      // porlo nella resolve della promise axios.
      // Da: https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
      // vediamo quindi che dobbiamo chiamare window.open prima della chiamata asincrona,
      // quindi settare la location quando questa ritorna.
      // Se la chiamata non va a buon fine invochiamo il close per chiudere il tab aperto.
      this.overlay_show = true;

      let window_ref = window.open();

      // Passiamo il parametro service che specifica a quale servizio vogliamo essere rimandati.
      axios.post( apiUrl.welfareapi.create_acq_salabam_login , { service : this.service_name } )
      .then( (response) => {
        // OK! Andiamo verso l'url indicato e qui facciamo vedere la pagina di cortesia.
        window_ref.location = response.data.login_url;
        this.overlay_show = false;
        this.$router.replace( { name : 'conv-redirect', params:  { page_title : this.service_title } } );
      })
      .catch( (error) => {
        // Chiudiamo la window aperta precedentemente e visualizziamo il messaggio di errore.
        window_ref.close();
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  props : {
    /**
     * Titolo del servizio Salabam richiesto
    */
    service_title: {
        type: String,
        required: true
    },
    /**
     * Nome del servizio Salabam presso il quale loggarsi.
     * Questo nome viene passato alla chiamata per l'ottenimento
     * dell'URL di accesso, ed in base ad esso si verrà mandati
     * presso un portale piuttosto che un altro.
     */
    service_name: {
        type: String,
        required : true
    },
    conditions_text_bold: {
      type: Boolean,
      required: false,
    }
  },
  components :{
    CustomOverlay
  }
}
</script>

<style scoped></style>